'use client';

const LEADFEEDER_TRACKER_ID = 'Xbp1oaE50zXaEdVj';
const ENABLE_IN_DEV = false;

type LeadfeederFn = ((...args: unknown[]) => void) & { _q?: unknown[] };

declare global {
  interface Window {
    ldfdr?: LeadfeederFn;
    __leadfeederLoaded?: boolean;
  }
}

function ensureQueueShim() {
  if (window.ldfdr) return;
  const q: unknown[] = [];
  const shim = ((...args: unknown[]) => {
    q.push(args);
  }) as LeadfeederFn;
  shim._q = q;
  window.ldfdr = shim;
}

export function injectLeadfeeder(): Promise<void> {
  return new Promise((resolve) => {
    const isAllowed = process.env.NODE_ENV === 'production' || ENABLE_IN_DEV;
    if (!isAllowed || window.__leadfeederLoaded) {
      resolve();
      return;
    }
    window.__leadfeederLoaded = true;
    ensureQueueShim();

    const s = document.createElement('script');
    s.async = true;
    s.src = `https://sc.lfeeder.com/lftracker_v1_${LEADFEEDER_TRACKER_ID}.js`;
    s.onload = () => resolve();
    s.onerror = () => resolve();
    (document.head || document.documentElement).appendChild(s);
  });
}
